import React, { Component } from "react";
import { connect } from "react-redux";
import { Dropdown, Table } from "semantic-ui-react";
import _ from "lodash";
import Case from "../dialogs/Case";
import settings from "../../settings";
import api from "../../api";
import { expireSession } from "../../actions/auth";
import CheckIcon from "../../assets/images/check_36x36.png";

class CaseComponent extends Component {
  state = {
    showCaseDialog: false,
    currentCaseData: null,
  };

  componentDidMount() {
    this.isCompMounted = true;
    this.loadOptions(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.loadOptions(nextProps);
  }

  componentWillUnmount() {
    this.isCompMounted = false;
    localStorage.removeItem("newFolderCode");
  }

  isCompMounted = false;

  loadOptions = (props) => {
    const options = [
      { key: "case_-2", value: -2, text: "Add to Case" },
      { key: "case_-1", value: -1, text: "Create New Case" },
    ];
    const { userCases } = props;
    if (
      userCases &&
      userCases.Folders !== undefined &&
      userCases.Folders.length > 0
    ) {
      _.forEach(userCases.Folders, (folder) => {
        const folderCode = parseInt(folder.folderCode, 10);
        options.push({
          key: `case_${folderCode}`,
          value: folderCode,
          text: folder.folderName,
        });
      });
    }
    let selectedOption = options[0];
    if (localStorage.newFolderCode !== undefined) {
      selectedOption = _.find(
        options,
        (o) => o.value === parseInt(localStorage.newFolderCode, 10)
      );
    } else if (localStorage.selectedFolderCode !== undefined) {
      selectedOption = _.find(
        options,
        (o) => o.value === parseInt(localStorage.selectedFolderCode, 10)
      );
    } else {
      localStorage.selectedFolderCode = selectedOption.value;
    }
    if (this.isCompMounted)
      this.setState({ options, currentOption: selectedOption || options[0] });
  };

  caseChanged = (e, data) => {
    const caseCheck = document.getElementById(
      `caseCheck_${this.props.compType}`
    );
    if (caseCheck) caseCheck.style.display = "none";
    if (data.value === -1) {
      if (this.isCompMounted)
        this.setState({ showCaseDialog: true, currentCaseData: null });
    } else if (data.value !== -2 && this.props.userCases) {
      const currentCaseData = _.find(
        this.props.userCases.Folders,
        (f) => f.folderCode === data.value
      );
      if (currentCaseData && this.isCompMounted)
        this.setState({
          currentCaseData,
          currentOption: {
            key: `case_${currentCaseData.folderCode}`,
            value: currentCaseData.folderCode,
            text: currentCaseData.folderName,
          },
        });
      if (this.props.persistCaseSelection) {
        localStorage.selectedFolderCode = currentCaseData.folderCode;
      } else if (localStorage.selectedFolderCode === -1)
        localStorage.selectedFolderCode = -2;
      this.updateCaseContents(
        currentCaseData.folderCode,
        this.props.actId ? [this.props.actId] : []
      );
    } else {
      // if (this.props.persistCaseSelection)
      // localStorage.selectedFolderCode = data.value;
      // else localStorage.selectedFolderCode = -2;
      const currentOption = _.find(
        this.state.options,
        (o) => o.value === data.value
      );
      if (this.isCompMounted) this.setState({ currentOption });
    }
  };

  updateCaseContents = (folderCode, checkedActs) => {
    const params = {
      sserver: settings.appName,
      usercode: this.props.user.userid,
      folderCode,
      contents: checkedActs,
      isUpdate: true,
      sessionID: localStorage.getItem("sessionID"),
    };
    api.lp
      .updateCaseContents(params)
      .then((res) => {
        if (res !== undefined && res.errors !== undefined) {
          if (_.get(res, "errors.error.errType") === "unauthorized") {
            this.props.expireSession();
          }
        }
        // else {
        //   this.props.viewCaseActivitiesPane();
        // }
        // this.props.onLoadComplete();
        const caseCheck = document.getElementById(
          `caseCheck_${this.props.compType}`
        );
        if (caseCheck) caseCheck.style.display = "block";
      })
      .catch((err) => console.log("load case view activities error - ", err));
  };

  updateCase = (caseData) => {
    if (this.isCompMounted) {
      const options = this.state.options;
      options.push({
        key: `case_${caseData.folderCode}`,
        value: caseData.folderCode,
        text: caseData.folderName,
      });
      this.setState({
        options,
        currentCaseData: caseData,
        currentOption: {
          key: `case_${caseData.folderCode}`,
          value: caseData.folderCode,
          text: caseData.folderName,
        },
      });
    }
    this.updateCaseContents(caseData.folderCode, [this.props.actId]);
    // localStorage.selectedFolderCode = caseData.folderCode;
  };

  dialogClose = () => {
    if (this.isCompMounted) this.setState({ showCaseDialog: false });
  };

  render() {
    const { userAccount } = this.props;
    return (
      <div>
        <Table
          className={
            userAccount.acctTheme === 0
              ? "table-no-border-and-padding background-color-transparent"
              : "table-no-border-and-padding"
          }
        >
          <Table.Body>
            <Table.Row>
              <Table.Cell className={"icon-align-middle"}>
                <img
                  id={`caseCheck_${this.props.compType}`}
                  src={CheckIcon}
                  alt="check"
                  width="20px"
                  height="20px"
                  style={{ display: "none", marginRight: "10px" }}
                />
              </Table.Cell>
              <Table.Cell>
                <Dropdown
                  fluid
                  search
                  selectOnBlur={false}
                  selection
                  id="cmbCases"
                  value={
                    this.state.currentOption !== undefined
                      ? this.state.currentOption.value
                      : ""
                  }
                  options={
                    this.state.options === undefined ? [] : this.state.options
                  }
                  onChange={(e, data) => this.caseChanged(e, data)}
                />
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>

        <Case
          dialogProps={{
            title:
              this.state.currentCaseData !== null
                ? this.state.currentCaseData.folderName
                : "New Case",
            data: this.state.currentCaseData,
          }}
          active={this.state.showCaseDialog}
          dialogClose={this.dialogClose}
          updateCase={this.updateCase}
          persistCaseSelection={this.props.persistCaseSelection}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    uiData: state.uiData,
    user: state.user,
    userAccount: state.userAccount,
    userCases:
      state.userCases && state.userCases.userCases
        ? state.userCases.userCases
        : undefined,
  };
}

export default connect(mapStateToProps, { expireSession })(CaseComponent);



// WEBPACK FOOTER //
// ./src/components/common/CaseComponent.js